import { type WorkOrder } from 'types/Squares/WorkOrderManagement/work.order.management.types';

// Augmented type for UI consumption
export interface ProcessedWorkOrder extends WorkOrder {
  id: string | number;
  assignedUserName: string;
  approvedByName: string;
  bumperNumber: string;
  make: string;
  model: string;
  assetType: string;
  approvedOn: string;
  createdAt: string;
  updatedAt: string;
  partsCost: number;
  laborCost: number;
  totalCost: number;
  actualStartDate: string | null;
  actualEndDate: string | null;
  maintenanceType: string | null;
}

type AssetMap = Record<
  string,
  {
    bumperNumber: string;
    make: string;
    model: string;
    assetType: string;
  }
>;

type UserMap = Record<string, string>;

export const processWorkOrdersForTabularView = (
  workOrders: WorkOrder[],
  assetMap: AssetMap,
  userMap: UserMap
): ProcessedWorkOrder[] => {
  const formatDate = (date?: string | null | undefined) => date ?? '';

  const processSingle = (workOrder: WorkOrder): ProcessedWorkOrder => {
    const assetDetails = assetMap?.[workOrder?.assetId] || {};
    return {
      ...workOrder,
      id: workOrder?.workOrderId || Date.now(),
      assignedUserName: workOrder?.assignedUserId
        ? userMap?.[workOrder?.assignedUserId]
        : '',
      approvedByName: workOrder?.approvedBy
        ? userMap?.[workOrder?.approvedBy]
        : '',
      bumperNumber: assetDetails?.bumperNumber || '',
      make: assetDetails?.make || '',
      model: assetDetails?.model || '',
      assetType: assetDetails?.assetType || '',

      // Date fields - formatted
      approvedOn: formatDate(workOrder?.approvedOn),
      createdAt: formatDate(workOrder?.createdAt),
      updatedAt: formatDate(workOrder?.updatedAt),
      partsCost: workOrder?.partsCost ?? 0,
      laborCost: workOrder?.laborCost ?? 0,
      totalCost: workOrder?.totalCost ?? 0,
      actualStartDate: workOrder?.actualStartDate ?? null,
      actualEndDate: workOrder?.actualEndDate ?? null,
      maintenanceType: workOrder?.maintenanceType,
    };
  };

  return workOrders.map(processSingle);
};

export const formatNumber = (
  val: unknown,
  fallback: number | null | undefined | '' = NaN
): number | null | undefined | '' => {
  if (typeof val === 'number' && !isNaN(val)) return val;
  if (typeof val === 'string' && val.trim() !== '' && !isNaN(+val)) return +val;
  return fallback;
};
